/* eslint-disable linebreak-style */
export const StyledPreviewContainer = {
  height: '200px',
  width: '150px',
  mb: '15px',
  borderRadius: '5px'
};

export const StyledCardPreviewImg = {
  height: '50%',
  width: '100%',
  m: '0'
};

export const StyledCardContentSingle = {
  p: 0
};

export const StyledCardTypoName = {
  display: 'block',
  fontSize: '16px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '100%',
  p: '4px'
};

export const StyledCardTypoRat = {
  color: 'text.secondary',
  fontSize: '14px',
  px: '4px'
};

export const StyledCardBtn = {
  color: 'black',
  fontSize: 12,
  borderColor: '#446173'
};
